import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { WebScrollView, Space } from '@redlink/components/atoms';
import { useLocale } from '@redlink/assets/locale';
import { ListHeader } from '@redlink/components/muscles';
import { SummaryBlock } from './summaryBlock';
import { UserBlock } from './userBlock';
import { LinkBlock } from './linkBlock';
import { ShopBlock } from './shopBlock';
import { GalleryBlock } from './galleryBlock';

export const AdminReportsPage = memo(({ navigation }) => {
  const { styles } = useStyle();
  const { dictionary } = useLocale();

  return (
    <View style={styles.container}>
      <WebScrollView>
        <ListHeader title={dictionary.reports} />
        <Space size={20} />
        <SummaryBlock />
        <Space size={24} />
        <UserBlock />
        <Space />
        <LinkBlock />
        <Space />
        <GalleryBlock />
        <Space />
        <ShopBlock />
      </WebScrollView>
    </View>
  );
});

const useStyle = createUseStyle(({ colors, size }) => ({
  container: {
    flex: 1,
  },
  summariesContainer: {
    flexDirection: 'row',
  },
}));
